import {Component, OnInit, ViewChild} from '@angular/core';
import {Company} from './company';
import {CompanyService} from './company.service';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {DelConfModalComponent} from '../../shared/delete-confirmation-modal.component';
import {LoginService} from '../login/login.service';

import { CreateCompanyModalComponent } from './create-company/create-company-modal.component';



@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})

export class CompanyComponent implements OnInit {

  companies: Company[];
  userData: any;
  orderByField = 'name';
  reverseSort = false;
  dtRendered = false;
  loadingCompanies: boolean = false;
  dtOptions: DataTables.Settings = {};
  showCreateCompanyOffcanvas: boolean = false;
  showEditCompanyOffcanvas: boolean = false;
  companyToEdit: Company = null;

  constructor(
    private router: Router,
    private companyService: CompanyService,
    private modalService: NgbModal,
    private loginService: LoginService,
  ) { }


  ngOnInit() {

    /* Opciones para data tables */
    this.dtOptions = {
     "order": [[ 1, "asc" ]],
      responsive: true,
      paging: true,
      "language": {
        "decimal": ",",
        "thousands": "."
      }
    };


    this.getCompanies();
    this.getUserData();
  }

  getUserData() {
    this.loginService.getUser()
      .then(user => this.userData = user);
  }

  getCompanies(): void {

    this.loadingCompanies = true;
    this.companyService.getCompanies()
      .then(companies => {
        this.companies = companies;

        this.loadingCompanies = false;
      })
      .catch(error => {
        this.loadingCompanies = false;
      });


  }


  openDeleteModal(company) {
    const modal = this.modalService.open(DelConfModalComponent, {
      backdrop: 'static',
      keyboard: false,
      // size: 'sm',
      windowClass: 'rmv-modal',
    });
    modal.componentInstance.text = '<b>' + company.name + '</b>, ' + company.address + ', ' + company.cif;
    modal.componentInstance.type = 'company';
    modal.result.then((result) => {
      if (result === 'Accept') {
        this.removeCompnay(company);
      } else { }
    });
  }

  removeCompnay(company: Company): void {
    this.companyService.deleteCompany(company.id)
      .then(response => this.getCompanies());
  }

  trackByFn(index, item) {
    return index;
  }

  getDefaultOffice(company){

    for (let office of company.offices){

       if(office.isDefault)
       {
         return office;
       }

    }

    return null;

  }

  canEditCompany(company){

    if(this.userData.user.isExternal)
    {
        return false;
    }

    return true;

  }

  checkingCustomer:boolean = false;
  checkCompanyNav(company){
    this.checkingCustomer = true;
    this.companyService.checkNavCustomer(company.id)
    .then(response => {
  
      this.checkingCustomer = false;

    })
    .catch(error => {
      this.checkingCustomer = false;
    });
  }

  createCompanyModal() {
    this.showCreateCompanyOffcanvas = true;
  }

  openCreateCompanyOffcanvas() {
    this.showCreateCompanyOffcanvas = true;
  }

  closeCreateCompanyOffcanvas() {
    this.showCreateCompanyOffcanvas = false;
  }

  onCompanyCreated(company: Company) {
    this.getCompanies();
  }

  openEditCompanyOffcanvas(company: Company) {
    this.companyToEdit = company;
    this.showEditCompanyOffcanvas = true;
  }

  closeEditCompanyOffcanvas() {
    this.showEditCompanyOffcanvas = false;
    this.companyToEdit = null;
  }

  onCompanyUpdated(company: Company) {
    this.getCompanies();
  }

}
